//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ReportRemarkImportantCheckbox from './ReportRemarkImportantCheckbox.vue'

export default {
  components: {
    ReportRemarkImportantCheckbox
  },
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    imagesRemarks: {
      type: Array,
      default () {
        return []
      }
    },
    technologicalOperationsRemarks: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      blocksTypeRemark: []
    }
  },
  computed: {
    consumptionsRemarks: function () {
      return this.getGroupMaterialsRemarksArray('consumptions')
    },
    debitsRemarks: function () {
      return this.getGroupMaterialsRemarksArray('debits')
    },
    demountingsRemarks: function () {
      return this.getGroupMaterialsRemarksArray('demountings')
    },
    mountingsRemarks: function () {
      return this.getGroupMaterialsRemarksArray('mountings')
    },
    technologicalOperationsRemarksWithCommonRemark: function () {
      const remarks = []
      if (this.report.commonRemark && this.report.commonRemark.active === true) {
        remarks.push({ name: 'Общее замечание', ...this.report.commonRemark })
      }
      remarks.push(...this.technologicalOperationsRemarks)
      return remarks
    },
    remarks: function () {
      return [...this.debitsRemarks, ...this.consumptionsRemarks, ...this.demountingsRemarks, ...this.mountingsRemarks, ...this.imagesRemarks, ...this.technologicalOperationsRemarksWithCommonRemark]
    },
    remarksLength: function () {
      return this.remarks.length
    },
    remarksDoneLength: function () {
      return this.remarks.filter(remark => remark.done).length
    }
  },
  watch: {
    remarksLength: {
      handler: function (value) {
        this.$emit('remarks-count', this.remarksLength)
        if (this.remarksLength === 0) {
          this.collapsePanel = []
        } else {
          this.collapsePanel = [0]
        }
      },
      immediate: true
    },
    technologicalOperationsRemarksWithCommonRemark: {
      handler: function () {
        this.initBlocksTypeRemark()
        this.calculateDefaultReportRemark()
      },
      deep: true,
      immediate: true
    },
    debitsRemarks: {
      handler: function () {
        this.initBlocksTypeRemark()
        this.calculateDefaultReportRemark()
      },
      deep: true,
      immediate: true
    },
    consumptionsRemarks: {
      handler: function () {
        this.initBlocksTypeRemark()
        this.calculateDefaultReportRemark()
      },
      deep: true,
      immediate: true
    },
    demountingsRemarks: {
      handler: function () {
        this.initBlocksTypeRemark()
        this.calculateDefaultReportRemark()
      },
      deep: true,
      immediate: true
    },
    mountingsRemarks: {
      handler: function () {
        this.initBlocksTypeRemark()
        this.calculateDefaultReportRemark()
      },
      deep: true,
      immediate: true
    },
    imagesRemarks: {
      handler: function () {
        this.initBlocksTypeRemark()
        this.calculateDefaultReportRemark()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    initBlocksTypeRemark: function () {
      const blocks = [
        { key: 'imagesRemarks', name: 'Замечания по фотографиям', data: this.imagesRemarks },
        { key: 'technologicalOperationsRemarks', name: 'Замечания по выполненным работам', data: this.technologicalOperationsRemarksWithCommonRemark },
        { key: 'debitsRemarks', name: 'Замечания по списаниям', data: this.debitsRemarks },
        { key: 'consumptionsRemarks', name: 'Замечания по расходу вне склада', data: this.consumptionsRemarks },
        { key: 'demountingsRemarks', name: 'Замечания по демонтажу', data: this.demountingsRemarks },
        { key: 'mountingsRemarks', name: 'Замечания по монтажу', data: this.mountingsRemarks }
      ]

      this.blocksTypeRemark = blocks.map(block => ({
        ...block,
        pagination: {
          rowsPerPage: 0,
          page: 1
        }
      }))
    },
    getGroupMaterialsRemarksArray: function (groupKey) {
      const allReportsRemarks = {}
      const reports = this.report.reports ? this.report.reports : [this.report]
      for (const report of reports) {
        const reportRemarks = report._materialsGroups.getGroup(groupKey).allRemarks
        if (reportRemarks.length && reportRemarks[0].reportName) {
          if (reportRemarks[0].name) {
            allReportsRemarks[reportRemarks[0].reportName] = [...reportRemarks]
          } else {
            allReportsRemarks[reportRemarks[0].reportName] = []
          }
        }
      }

      const remarksArray = []
      Object.keys(allReportsRemarks).forEach(key => {
        allReportsRemarks[key].forEach(remark => {
          remarksArray.push(remark)
        })
      })
      return remarksArray
    },
    calculateDefaultReportRemark: function () {
      const remarks = []

      // Фото
      if (this.imagesRemarks.length) {
        const categoriesKeys = new Set()
        for (const imagesRemark of this.imagesRemarks) {
          if (!categoriesKeys.has(imagesRemark.code)) { // исключаем повторения замечаний к одной секции
            categoriesKeys.add(imagesRemark.code)
            remarks.push(
              imagesRemark.name && !imagesRemark.name.includes('Фото') && !imagesRemark.name.includes('Видео')
                ? ('Фото ' + imagesRemark.name.toLowerCase())
                : imagesRemark.name
            )
          }
        }
      }

      // Чек-лист
      if (this.report.commonRemark && this.report.commonRemark.active === true) {
        remarks.push('Чек-лист выполненных работ')
      }
      for (const remark of this.technologicalOperationsRemarks) {
        remarks.push(remark.name)
      }

      // Материалы
      if (this.hasRemarks(this.debitsRemarks)) {
        remarks.push('Списанные материалы')
      }
      if (this.hasRemarks(this.consumptionsRemarks)) {
        remarks.push('Расход')
      }
      if (this.hasRemarks(this.demountingsRemarks)) {
        remarks.push('Демонтаж')
      }
      if (this.hasRemarks(this.mountingsRemarks)) {
        remarks.push('Монтаж')
      }

      let reportRemark = null
      if (remarks.length) {
        const remarksText = remarks.map((val, index) => `${index + 1}. ${val}`).join('\n')
        reportRemark = 'Требуется доработка по следующим разделам:\n' + remarksText
      } else {
        reportRemark = ''
      }

      this.report.defaultRemark = reportRemark
      this.$emit('default-remark', reportRemark)
    },
    hasRemarks: function (materialsRemarksByReport) {
      if (materialsRemarksByReport && materialsRemarksByReport.length) {
        for (const materialsRemark of materialsRemarksByReport) {
          if (materialsRemark && materialsRemark.name) {
            return true
          }
        }
      }
      return false
    },
    getColumns: function (type) {
      let columns = []
      switch (type) {
        case 'imagesRemarks' :
          columns = [
            {
              name: 'name',
              label: 'Секция',
              align: 'left',
              field: 'name',
              classes: 'class-bordered',
              width: 50
            },
            {
              name: 'comment',
              label: 'Замечание',
              align: 'left',
              field: 'comment',
              classes: 'class-bordered',
              width: 50
            },
            {
              name: 'filesText',
              label: 'Файлы',
              align: 'left',
              field: 'filesText',
              classes: 'class-bordered',
              width: 50
            }
          ]
          break
        case 'technologicalOperationsRemarks' :
          columns = [
            {
              name: 'name',
              label: 'Операция',
              align: 'left',
              field: 'name',
              classes: 'class-bordered',
              width: 50
            },
            {
              name: 'comment',
              label: 'Замечание',
              align: 'left',
              field: 'comment',
              classes: 'class-bordered',
              width: 50
            }
          ]
          break
        case 'debitsRemarks' :
        case 'consumptionsRemarks' :
        case 'demountingsRemarks' :
        case 'mountingsRemarks' :
          columns = [
            {
              name: 'name',
              label: 'Материал',
              align: 'left',
              field: 'name',
              classes: 'class-bordered',
              width: 50
            },
            {
              name: 'comment',
              label: 'Комментарий',
              align: 'left',
              field: 'comment',
              classes: 'class-bordered',
              width: 50
            }
          ]
          if (this.report.reports) {
            columns.push({
              name: 'reportName',
              label: 'Отчёт',
              align: 'left',
              field: 'reportName',
              classes: 'class-bordered',
              width: 50
            })
          }
          break
        default:
          break
      }
      return columns
    }
  }
}

